import type { FunnelPhase } from "../models/constants";
import { FUNNEL_PHASE } from "../models/constants";

const BASE_ROUTE = "/onboarding/funnel";

export const FUNNEL_ROUTE = {
  BASE: BASE_ROUTE,
  MEASUREMENTS: `${BASE_ROUTE}/measurements`,
  PERSONAL_INFO: `${BASE_ROUTE}/personal-info`,
  MEDICAL_REVIEW: `${BASE_ROUTE}/medical-review`,
  CONTACT: `${BASE_ROUTE}/contact`,
  PRICING: `${BASE_ROUTE}/pricing`,
  PAYMENT: `${BASE_ROUTE}/payment`,
  DISQUALIFIED: `${BASE_ROUTE}/disqualified`,
  INTAKE: `${BASE_ROUTE}/intake`,
} as const;

export const funnelIntakeRoute = (slug: string) =>
  `${FUNNEL_ROUTE.INTAKE}/${slug}`;

export const funnelDisqualifiedRoute = (slug: string) =>
  `${FUNNEL_ROUTE.DISQUALIFIED}/${slug}`;

/**
 * Ordered list of every step route together with the phase it belongs to.
 * Drives both progress calculation and the stepper's active/completed state.
 */
export const FUNNEL_STEPS: readonly { route: string; phase: FunnelPhase }[] = [
  { route: FUNNEL_ROUTE.MEASUREMENTS, phase: FUNNEL_PHASE.START },
  { route: FUNNEL_ROUTE.PERSONAL_INFO, phase: FUNNEL_PHASE.START },
  { route: FUNNEL_ROUTE.MEDICAL_REVIEW, phase: FUNNEL_PHASE.ELIGIBILITY },
  { route: FUNNEL_ROUTE.CONTACT, phase: FUNNEL_PHASE.ELIGIBILITY },
  { route: FUNNEL_ROUTE.PRICING, phase: FUNNEL_PHASE.ELIGIBILITY },
  { route: FUNNEL_ROUTE.PAYMENT, phase: FUNNEL_PHASE.ELIGIBILITY },
] as const;

export const FUNNEL_PHASES: readonly FunnelPhase[] = [
  FUNNEL_PHASE.START,
  FUNNEL_PHASE.PRELIMINARY,
  FUNNEL_PHASE.HEALTH,
  FUNNEL_PHASE.DETAILS,
  FUNNEL_PHASE.ELIGIBILITY,
];
